import Util               from "../../utils/Util"

/**
 * Represents the property "attribute_value_valuable.material_group.materials" within the AttributeMaterialGroupValue
 * class.
 * This is used to display the user the options for the material groups, in the first place it is used for the selection
 * of the decors.
 */
export default class ValuableMaterial {
    constructor(data) {
        this.data = data
    }

    /**
     * Returns a value by key. The key may be nested using . Notation.
     *
     * @param key
     * @param defaultValue
     * @returns {boolean|*}
     */
    get(key, defaultValue = null) {
        return Util.getNestedProperty(this.data, key, defaultValue)
    }

    /**
     * Returns the ID
     *
     * @returns {boolean|*}
     */
    getId() {
        return this.get('id')
    }

    /**
     * Returns the ID of the material
     *
     * @returns {boolean|*}
     */
    getMaterialId() {
        return this.get('material_id')
    }

    /**
     * Returns the name of the material
     *
     * @returns {boolean|*}
     */
    getMaterialName() {
        return this.get('material_name')
    }

    /**
     * Returns the name for the material. This is the option name that may be displayed to the user.
     *
     * @customizable in the Expivi Backend
     * @returns {boolean|*}
     */
    getName() {
        return this.get('name')
    }

    /**
     * Returns wheather the thumbnail_url exists or not.
     *
     * @returns {boolean}
     */
    hasThumbnailUrl() {
        return this.get('thumbnail_url', '').length > 0
    }

    /**
     * Returns the URL of the thumbnail if the thumbnail has been uploaded to the expivi backend
     *
     * @returns {boolean|*}
     */
    getThumbnailUrl() {
        return this.get('thumbnail_url', '')
    }

    /**
     * Returns wheater the material is selected as default material
     *
     * @returns {boolean|*}
     */
    isDefault() {
        return this.get('default_selected')
    }

    /**
     * Returns the price of the option
     *
     * @returns {boolean|*}
     */
    getPrice() {
        return this.get('price')
    }

    /**
     * Returns the SKU of the option
     *
     * @returns {boolean|*}
     */
    getSku() {
        return this.get('sku')
    }

    isVisible() {
        return this.get('visible', false)
    }
}
